module.exports = __webpack_public_path__ + "static/media/Tiresias.16ddb273.jpg";